import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Directive, HostBinding, ElementRef, Component, Inject, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { mixinFocusEvent, mixinBlurEvent, mixinClickEvent, FadvBaseComponent, Forward, focusEventOutput, blurEventOutput, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/button/button';

class FadvButtonCaretDirective {
    constructor() {
        this.slotName = 'caret';
    }
}
FadvButtonCaretDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvButtonCaretDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
FadvButtonCaretDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.2.3", type: FadvButtonCaretDirective, selector: "fadv-icon[fadvButtonCaret]", host: { properties: { "slot": "this.slotName" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvButtonCaretDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'fadv-icon[fadvButtonCaret]',
                }]
        }], propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }] } });
class FadvButtonComponent extends mixinFocusEvent(mixinBlurEvent(mixinClickEvent(FadvBaseComponent))) {
    constructor(el) {
        super(el);
        this.circle = null;
    }
}
FadvButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvButtonComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvButtonComponent, selector: "fadv-button", inputs: { variant: "variant", size: "size", caret: "caret", disabled: "disabled", loading: "loading", outline: "outline", pill: "pill", circle: "circle", type: "type", block: "block", rectangle: "rectangle", name: "name", value: "value", href: "href", target: "target", download: "download" }, outputs: { focused: "focused", blurred: "blurred" }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvButtonComponent.prototype, "variant", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "size", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "caret", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "disabled", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "loading", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "outline", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "pill", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "circle", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "type", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "block", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "rectangle", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "name", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "value", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "href", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "target", void 0);
__decorate([
    Forward()
], FadvButtonComponent.prototype, "download", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-button',
                    template: '<ng-content></ng-content>',
                    outputs: [focusEventOutput, blurEventOutput],
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { variant: [{
                type: Input
            }], size: [{
                type: Input
            }], caret: [{
                type: Input
            }], disabled: [{
                type: Input
            }], loading: [{
                type: Input
            }], outline: [{
                type: Input
            }], pill: [{
                type: Input
            }], circle: [{
                type: Input
            }], type: [{
                type: Input
            }], block: [{
                type: Input
            }], rectangle: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], href: [{
                type: Input
            }], target: [{
                type: Input
            }], download: [{
                type: Input
            }] } });

class FadvButtonModule {
}
FadvButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvButtonModule, declarations: [FadvButtonComponent, FadvButtonCaretDirective], imports: [FadvCommonModule], exports: [FadvButtonComponent, FadvButtonCaretDirective] });
FadvButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvButtonModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvButtonComponent, FadvButtonCaretDirective],
                    imports: [FadvCommonModule],
                    exports: [FadvButtonComponent, FadvButtonCaretDirective],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvButtonCaretDirective, FadvButtonComponent, FadvButtonModule };
